import { gql } from '@/__generated__/storefront';

export const kitItemsQuery = gql(`
  query KitItems($ids: [ID!]!, $country: CountryCode!) @inContext(country: $country) {
    nodes(ids: $ids) {
      ... on ProductVariant {
        id
        title
        availableForSale
        image {
          url
        }
        product {
          title
        }
      }
    }
  }
`);
